import api from "../../api/cofocusAPI";

const StyleAPI = {
  async getUserStyles(UID) {
    if (!UID) {
      throw new Error("Required data not provided for request.");
    }
    return api.getResponseData({
      url: `/api/styles/${UID}`,
      method: "get",
      params: { UID },
      withCredentials: true,
    });
  },
  async setNewTheme(UID, themeData) {
    if (!UID || !themeData) {
      throw new Error("Required data not provided for request.");
    }
    return api.getResponseData({
      url: `/api/styles/${UID}/theme`,
      method: "post",
      data: { UID, themeData },
      withCredentials: true,
    });
  },
};

export default StyleAPI;
